window.global ||= window; // Required by SockJS for initialization: use it before any other import in the application
